export default [
  { displayvalue: 1, displayname: 'Monday' },
  { displayvalue: 2, displayname: 'Tuesday' },
  { displayvalue: 3, displayname: 'Wednesday' },
  { displayvalue: 4, displayname: 'Thursday' },
  { displayvalue: 5, displayname: 'Friday' },
  { displayvalue: 6, displayname: 'Saturday' },
  { displayvalue: 7, displayname: 'Sunday' },
];
